import appConfig from 'app-config';
import useCssMediaDevice from 'src/hooks/useCssMediaDevice';
import { withTranslations } from 'src/i18n/static-generation';
import type { PageMetas } from 'src/types/meta';
import MessagesView from 'src/views/Messages';
import MessagesDesktopView from 'src/views/MessagesDesktop';
export default function Page() {
  const device = useCssMediaDevice();
  const View = device === 'desktop' ? MessagesDesktopView : MessagesView;
  if (!appConfig.features.dm.enabled) {
    return null;
  }
  return <View data-sentry-element="View" data-sentry-component="Page" data-sentry-source-file="index.tsx" />;
}
export const getStaticProps = withTranslations<PageMetas>(async () => {
  if (!appConfig.features.dm.enabled) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      noindex: true
    }
  };
});